var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.author.name))]), _c('b-badge', {
    staticClass: "mr-1",
    attrs: {
      "variant": _vm.statusVariant(_vm.author.status)
    }
  }, [_vm._v(_vm._s(_vm.author.status))]), _vm.author.status === 'pending' && _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_REVIEW, _vm.permissions) ? [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.onStatusChange('approved');
      }
    }
  }, [_vm._v(" Approve ")]), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        return _vm.onStatusChange('rejected');
      }
    }
  }, [_vm._v(" Reject ")])] : _vm._e()], 2)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Contact:")]), _c('p', [_vm._v(_vm._s(_vm.author.contact || 'N/A'))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Total Payment:")]), _c('p', [_vm._v(_vm._s(_vm.author.total_payment))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Total Posts:")]), _c('p', [_vm._v(_vm._s(_vm.author.total_posts_approved))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Avg Per Post Cost:")]), _c('p', [_vm._v(_vm._s(_vm.author.per_post_cost) + " "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(avg)")])])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Posts Used:")]), _c('p', [_vm._v(_vm._s(_vm.author.posts_used))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Posts Remaining:")]), _c('p', [_vm._v(_vm._s(_vm.author.posts_remaining))])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Notes:")]), _c('p', [_vm._v(_vm._s(_vm.author.notes || 'N/A'))])])], 1), _c('hr'), _c('h5', [_vm._v("Websites")]), _vm.author.websites && _vm.author.websites.data && _vm.author.websites.data.length ? _c('b-table', {
    attrs: {
      "items": _vm.author.websites.data,
      "fields": _vm.websiteFields,
      "striped": "",
      "small": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(url)",
      fn: function fn(data) {
        return [_c('a', {
          attrs: {
            "href": data.item.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(data.item.url))])];
      }
    }, {
      key: "cell(traffic_value)",
      fn: function fn(data) {
        return [data.value != null ? _c('span', [_vm._v("$" + _vm._s(data.value))]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("N/A")])];
      }
    }, {
      key: "cell(is_approved)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value ? 'light-success' : 'light-warning'
          }
        }, [_vm._v(" " + _vm._s(data.value ? 'Approved' : 'Pending') + " ")])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [!data.item.is_approved && _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_REVIEW, _vm.permissions) ? _c('b-button', {
          attrs: {
            "variant": "success",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.onApproveWebsite(data.item.id);
            }
          }
        }, [_vm._v(" Approve ")]) : _c('span', [_vm._v("-")])];
      }
    }], null, false, 710997773)
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No websites added.")]), _c('hr'), _c('h5', [_vm._v("Approved Niches")]), _vm.author.niches && _vm.author.niches.data && _vm.author.niches.data.length ? _c('div', _vm._l(_vm.author.niches.data, function (niche) {
    return _c('b-badge', {
      key: niche.id,
      staticClass: "mr-1",
      attrs: {
        "variant": "light-primary"
      }
    }, [_vm._v(" " + _vm._s(niche.name) + " ")]);
  }), 1) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No niches assigned.")]), _c('hr'), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center pb-1"
  }, [_c('h5', [_vm._v("Payment History")]), _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_TOPUP, _vm.permissions) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": _vm.showTopUpModal
    }
  }, [_vm._v(" Add Top-Up ")]) : _vm._e()], 1), _vm.historyRows.length ? _c('b-table', {
    attrs: {
      "items": _vm.historyRows,
      "fields": _vm.historyFields,
      "striped": "",
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(topup_date)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.value)) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.historyStatusVariant(data.value)
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('div', [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "info",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.showTopUpViewModal(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EyeIcon"
          }
        })], 1), data.item.status === 'pending' && _vm.$permissionAbility(_vm.OUTREACH_AUTHOR_REVIEW, _vm.permissions) ? [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "success",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.openReviewModal(data.item, 'approved');
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "CheckIcon"
          }
        })], 1), _c('b-button', {
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.openReviewModal(data.item, 'rejected');
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "XIcon"
          }
        })], 1)] : data.item.reviewer_remarks ? _c('span', [_vm._v(_vm._s(data.item.reviewer_remarks))]) : _vm._e()], 2)];
      }
    }], null, false, 916254222)
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No payment history.")]), _vm.historyTotalRecords > _vm.historyPageLength ? _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-pagination', {
    staticClass: "mt-1 mb-0",
    attrs: {
      "total-rows": _vm.historyTotalRecords,
      "per-page": _vm.historyPageLength,
      "first-number": "",
      "last-number": "",
      "align": "right"
    },
    on: {
      "input": _vm.onHistoryPageChange
    },
    scopedSlots: _vm._u([{
      key: "prev-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronLeftIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }, {
      key: "next-text",
      fn: function fn() {
        return [_c('feather-icon', {
          attrs: {
            "icon": "ChevronRightIcon",
            "size": "18"
          }
        })];
      },
      proxy: true
    }], null, false, 1308952388),
    model: {
      value: _vm.historyCurrentPage,
      callback: function callback($$v) {
        _vm.historyCurrentPage = $$v;
      },
      expression: "historyCurrentPage"
    }
  })], 1) : _vm._e(), _c('top-up-modal', {
    attrs: {
      "author-id": _vm.authorId
    },
    on: {
      "topup-created": _vm.onTopUpCreated
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-review",
      "centered": "",
      "title": _vm.reviewAction === 'approved' ? 'Approve Top-Up' : 'Reject Top-Up',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('p', [_vm._v("Are you sure you want to "), _c('strong', [_vm._v(_vm._s(_vm.reviewAction))]), _vm._v(" this top-up?")]), _vm.reviewBatch ? _c('p', [_vm._v("Amount: " + _vm._s(_vm.reviewBatch.amount) + " | Posts: " + _vm._s(_vm.reviewBatch.posts_added))]) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Reviewer Remarks"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Optional remarks",
      "rows": "2"
    },
    model: {
      value: _vm.reviewerRemarks,
      callback: function callback($$v) {
        _vm.reviewerRemarks = $$v;
      },
      expression: "reviewerRemarks"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-review');
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    attrs: {
      "variant": _vm.reviewAction === 'approved' ? 'success' : 'danger'
    },
    on: {
      "click": _vm.submitReview
    }
  }, [_vm._v(" " + _vm._s(_vm.reviewAction === 'approved' ? 'Approve' : 'Reject') + " ")])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-topup-view",
      "centered": "",
      "title": "Top-Up Details",
      "hide-footer": ""
    }
  }, [_vm.selectedTopUp ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Date")]), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.selectedTopUp.created_at)))])]), _c('tr', [_c('th', [_vm._v("Top Up Date")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.topup_date ? _vm.formatDate(_vm.selectedTopUp.topup_date) : 'N/A'))])]), _c('tr', [_c('th', [_vm._v("Amount")]), _c('td', [_vm._v(_vm._s(_vm.amountWithCurrency(_vm.selectedTopUp)))])]), _c('tr', [_c('th', [_vm._v("Posts Added")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.posts_added))])]), _c('tr', [_c('th', [_vm._v("Avg Per Post Cost")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.per_post_cost))])]), _c('tr', [_c('th', [_vm._v("Status")]), _c('td', [_c('b-badge', {
    attrs: {
      "variant": _vm.historyStatusVariant(_vm.selectedTopUp.status)
    }
  }, [_vm._v(_vm._s(_vm.selectedTopUp.status))])], 1)]), _c('tr', [_c('th', [_vm._v("Note")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.note || 'N/A'))])]), _vm.selectedTopUp.reviewer_remarks ? _c('tr', [_c('th', [_vm._v("Reviewer Remarks")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.reviewer_remarks))])]) : _vm._e(), _c('tr', [_c('th', [_vm._v("Added By")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.created_by))])]), _vm.selectedTopUp.reviewed_by ? _c('tr', [_c('th', [_vm._v("Reviewed By")]), _c('td', [_vm._v(_vm._s(_vm.selectedTopUp.reviewed_by))])]) : _vm._e(), _vm.selectedTopUp.reviewed_at ? _c('tr', [_c('th', [_vm._v("Reviewed At")]), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.selectedTopUp.reviewed_at)))])]) : _vm._e(), _c('tr', [_c('th', [_vm._v("Attachments")]), _c('td', [_vm.selectedTopUp.attachments && _vm.selectedTopUp.attachments.length ? _c('div', _vm._l(_vm.selectedTopUp.attachments, function (attachment) {
    return _c('div', {
      key: attachment.id
    }, [_c('a', {
      attrs: {
        "href": attachment.url,
        "target": "_blank"
      }
    }, [_c('feather-icon', {
      staticClass: "mr-25",
      attrs: {
        "icon": "EyeIcon"
      }
    }), _vm._v(_vm._s(attachment.file_name) + " ")], 1)]);
  }), 0) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("No attachments.")])])])])])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }